import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MailFolder from '../Modules/mails/components/MailFolder';
import { useMailFolder } from '../Modules/mails/hooks/useMailFolder';
import { MAIL_FOLDER_INBOX } from '../Modules/mails/constants';

const MailPage = () => {
    const { mailId } = useParams();
    const [folder, setFolder] = useMailFolder();

    useEffect(() => {
        if (mailId) {
            setFolder(MAIL_FOLDER_INBOX);
        }
    }, [mailId, setFolder]);

    return (
        <MailFolder
            selectedFolder={mailId ? MAIL_FOLDER_INBOX : folder}
            onChangeFolder={setFolder}
            mailId={mailId}
        />
    );
};

export default MailPage;